import { ArrowDown, ArrowUp } from "lucide-mui";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { formatNumber } from "../../utils/format.ts";

interface DeltaChipProps {
  value: number;
  label?: string;
  compact?: boolean;
}

export default function DeltaChip({ value, label, compact = false }: DeltaChipProps) {
  if (value === 0) return null;
  const positive = value > 0;
  const color = positive ? "success.main" : "error.main";
  const bg = positive ? "success.light" : "error.light";
  const Icon = positive ? ArrowUp : ArrowDown;
  const sign = positive ? "+" : "";

  if (compact) {
    return (
      <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.25, color }}>
        <Icon sx={{ fontSize: 14 }} />
        <Typography variant="caption" sx={{ color, fontWeight: 600, fontVariantNumeric: "tabular-nums" }}>
          {sign}
          {formatNumber(value)}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        px: 0.75,
        py: 0.25,
        borderRadius: 1,
        bgcolor: bg,
        color,
      }}
    >
      <Icon sx={{ fontSize: 14 }} />
      <Typography
        variant="caption"
        sx={{ color, fontWeight: 600, fontVariantNumeric: "tabular-nums" }}
      >
        {sign}
        {formatNumber(value)}
      </Typography>
      {label && (
        <Typography variant="caption" sx={{ color, opacity: 0.85 }}>
          {label}
        </Typography>
      )}
    </Box>
  );
}
